<mat-form-field2 class="search mat-block inline" [showLabel]="false">
  <input
    matInput
    type="text"
    [formControl]="searchCtrl"
    [matTooltip]="inputTooltip"
    matTooltipPosition="above"
    [placeholder]="inputPlaceholder"
    class="example-right-align"
  />

  <i matPrefix class="cs-icon cs-icon-search"></i>
  <i
    matSuffix
    *ngIf="searchCtrl.value?.length > 0"
    (click)="$event.stopPropagation(); onClearSearch()"
    [matTooltip]="clearTooltip"
    matTooltipPosition="above"
    class="cs-icon cs-icon-times text-sm text-danger clickable"
  ></i>
</mat-form-field2>
